"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjudicationStepDefinitions = void 0;
const adjudication_step_types_1 = require("./adjudication-step.types");
exports.AdjudicationStepDefinitions = {
    PackageDataAdjudication: {
        type: 'PackageDataAdjudication',
        displayName: 'Package data adjudication',
        inputSchema: adjudication_step_types_1.AdjudicationReviewInputSchema,
        outputSchema: adjudication_step_types_1.AdjudicationReviewOutputSchema,
    },
};
//# sourceMappingURL=adjudication-steps.js.map